import React, {useState} from "react";
import PageLinks from "./PageLinks";
import DropDown from "./DropDown";
import "../../stylesheets/social-media.css";

const Navbar: React.FC = () => {
  return (
    <nav className="navbarHome">
      <div className="links-container">
        <div className="nav-section left">
          <DropDown />
          <PageLinks
            parentClass="nav-links"
            itemClass="nav-link"
          />
        </div>
        <div className="nav-section right">
          <div className="social-media-links navbar-social">
            <a href="https://www.facebook.com/profile.php?id=100092147253061" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon facebook">
              Facebook
            </a>
            <a href="https://www.instagram.com/moralhahlafa_/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon instagram">
              Instagram
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
